<template>
	<vx-card class="admin-manager-sites-edit">
		<SitesList max-items="3" pagination :data="sitesProfilesPairs">
			<template slot-scope="{ data }">
				<vs-tr
					v-for="(pair, pairIndex) in data"
					:key="pairIndex"
				>
					<vs-td>
						<div class="vx-row">
							<div
								v-for="(siteProfile, siteIndex) in pair"
								:key="siteIndex"
								:class="`w-1/${data[0].length} manager-card-container`"
								class="vx-col"
							>
								<div class="manager-card w-full flex mt-5">
									<div class="manager-card__photo">
										<img
											v-if="editingProfile !== siteProfile.website_id"
											:src="siteProfile.photo"
										>
										<vs-simple-upload
											v-if="editingProfile === siteProfile.website_id"
											:showUploadButton="false"
											:text="$t('loadFile')"
											@change="uploadImage"
										/>
									</div>
									<div class="manager-card__info flex-grow flex flex-col">
										<div class="manager-card__site">
											{{ $getDeep(siteProfile.website_id, sites) }}
										</div>
										<div class="manager-card__name flex-grow">
											<vs-input
												v-model="siteProfile.username"
												:label="$t('nickname')"
												class="w-full"
											/>
										</div>
										<div class="manager-card__controls flex vx-row">
											<div class="manager-card__change vx-col w-1/2">
												<vs-button
													@click="editImage(siteProfile)"
													class="w-full h-full pl-1 pr-1"
												>{{ $t('changePhoto') }}</vs-button>
											</div>
											<div class="manager-card__delete vx-col w-1/2">
												<vs-custom-button
													@click="deletePhoto(siteProfile)"
													color="danger"
													type="border"
													class="w-full h-full pl-1 pr-1"
												>{{ $t('deletePhoto') }}</vs-custom-button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</vs-td>
				</vs-tr>
			</template>
			<template slot="append">
				<div class="append">
					<div class="append__container">
						<div class="append__btn">
							<vs-button @click="save" class="h-full w-full">
								{{ $t('save') }}
							</vs-button>
						</div>
						<div class="append__btn">
							<vs-custom-button
								@click="$router.back()"
								color="warning"
								type="border"
								class="h-full w-full"
							>{{ $t('cancel') }}</vs-custom-button>
						</div>
					</div>
				</div>
			</template>
		</SitesList>
	</vx-card>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import SitesList from "@/components/sites-list/SitesList";

export default {
	name: "MangerSitesProfiles",
	mixins: [databaseManager, notifier],
	components: {
		SitesList
	},
	data() {
		return {
			sites: [],
			sitesProfiles: [],
			editingProfile: null
		}
	},
	watch: {
		idManager() {
			this.updateProfiles();
		}
	},
	computed: {
		sitesProfilesPairs() {
			return this.getSitesProfilesPairs();
		},
		idManager() {
			return this.$route.params.id;
		}
	},
	methods: {
		editImage(profile) {
			this.editingProfile = profile.website_id !== this.editingProfile
				? profile.website_id
				: null;
		},
		async uploadImage(err, files) {
			const lastFile = files[files.length - 1];
			const urls = await this.dbUploadMany([lastFile]);
			const currentProfile = this.sitesProfiles
				.find(item => item.website_id === this.editingProfile);

			if(!currentProfile) return;

			currentProfile.photo = urls[0].fullUrl;
			this.editingProfile = null;
		},
		deletePhoto(profile) {
			profile.photo = '';
			this.editingProfile = null;
		},
		getSitesProfilesPairs() {
			const pairs = [];
			const columnsCount = 2;

			for(let i = 0; i < this.sitesProfiles.length; ) {
				const pair = [];

				for(let y = 0; y < columnsCount; y++) {
					if(i < this.sitesProfiles.length) {
						pair.push(this.sitesProfiles[i++]);
					}
				}

				pairs.push(pair);
			}

			return pairs;
		},
		fillMissingProfiles() {
			for(let site of this.sites) {
				const res = this.sitesProfiles.find(item => item.website_id === site.id);

				if(!res) {
					this.sitesProfiles.push({
						username: "",
						photo: "",
						website_id: site.id
					});
				}
			}
		},
		async updateProfiles() {
			this.sites = await this.dbGetWebSites();

			try {
				const role = this.$store.state.auth.role;
				if(role === "admin") {
					this.sitesProfiles = await this.dbGetManagerProfilesByAdmin(this.idManager);
				} else if(role === "manager") {
					this.sitesProfiles = await this.dbGetManagerProfiles();
				}

			} catch(e) {
				this.notifyError(e.message);
			}

			this.fillMissingProfiles();
		},
		async save() {
			try {
				const role = this.$store.state.auth.role;
				if(role === "admin") {
					await this.dbUpdateManagerProfilesByAdmin(this.idManager, this.sitesProfiles);

				} else if(role === "manager") {
					await this.dbUpdateManagerProfiles(this.sitesProfiles);
				}

				this.notifySuccess(this.$t('dataIsSaved'));
				this.$router.back();

			} catch(e) {
				this.notifyError(e.message);
			}
		}
	},
	async mounted() {
		await this.updateProfiles();
	}
};
</script>

<style lang="scss">
.admin-manager-sites-edit {
	max-width: 1200px;

	.vs-table--tbody-table {
		min-width: auto !important;
	}

	.manager-card-container {
		@media screen and (max-width: 570px) {
			width: 100% !important;
		}
	}

	.vx-row > .manager-card-container {
		@media screen and (max-width: 570px) {
			margin-bottom: 20px;

			&:last-child {
				margin-bottom: 0;
			}
		}
	}

	.manager-card {
		display: flex;

		&__photo {
			flex-shrink: 0;
			width: 180px;
			height: 180px;
			border-radius: 8px;
			overflow: hidden;

			img {
				width: 100%;
				height: 100%;
			}

			.con-upload,
			.con-img-upload,
			.con-input-upload {
				width: 100%;
				height: 100%;
				margin: 0;
				padding: 0;
			}
		}

		&__info {
			margin-left: 25px;
		}

		&__name {
			margin-top: 10px;
			word-wrap: anywhere;
		}

		&__site {
			font-size: 20px;
			font-weight: 600;
			word-wrap: anywhere;
		}

		&__controls {
			margin-top: 10px;
		}

		@media screen and (max-width: 1400px) {
			&__change,
			&__delete {
				width: 100% !important;
			}

			&__delete {
				margin-top: 10px;
			}

			&__info {
				margin-left: 15px;
			}
		}

		@media screen and (max-width: 992px) {
			flex-direction: column;
			align-items: center;

			&__info {
				margin-top: 5px;
				margin-left: 0;
			}

			&__photo {
				width: 252px;
				height: 252px;
			}

			&__site {
				margin-top: 10px;
			}
		}

		@media screen and (max-width: 768px) {
			&__photo {
				width: 217px;
				height: 217px;
			}
		}

		@media screen and (max-width: 570px) {
			&__photo {
				width: 210px;
				height: 210px;
			}
		}

		@media screen and (max-width: 370px) {
			&__photo {
				width: 160px;
				height: 160px;
			}
		}
	}

	.vs-table--pagination {
		width: auto;
	}

	.append {
		&__container {
			display: flex;
			margin: -10px;
		}

		&__btn {
			margin: 10px;
		}

		@media screen and (max-width: 570px) {
			display: flex;
			justify-content: center;
			width: 100%;

			&__container {
				max-width: 300px;
				flex-direction: column;
				width: 100%;
			}

			&__btn {
				width: 100%;
			}
		}
	}
}
</style>

